import React from 'react';
import ContactHero from './components/ContactHero';
import ContactMethods from './components/ContactMethods';
import ContactForm from './components/ContactForm';
import SocialConnect from './components/SocialConnect';
import LocationTimezone from './components/LocationTimezone';
import FAQSection from './components/FAQSection';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Main Content */}
      <main className="pt-16">
        <ContactHero />
        <ContactMethods />
        <ContactForm />
        <SocialConnect />
        <LocationTimezone />
        <FAQSection />
      </main>
      {/* Footer is handled globally */}
    </div>
  );
};

export default ContactPage;
